export default __webpack_public_path__ + "static/media/KLGR_Logo_Login_180.30255054.png";